import { render, staticRenderFns } from "./publish_question.vue?vue&type=template&id=de30b460&scoped=true&"
import script from "./publish_question.vue?vue&type=script&lang=js&"
export * from "./publish_question.vue?vue&type=script&lang=js&"
import style0 from "./publish_question.vue?vue&type=style&index=0&id=de30b460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de30b460",
  null
  
)

export default component.exports